<section *ngIf="amount" class="price-tag">
  <h2 class="price-tag_price" #priceTagAmount>
    <ng-container [ngSwitch]="offerQuotationState$ | async">
      <div *ngSwitchCase="apiState.success" class="flex gap-4 items-center text-nowrap">
        <span class="price-tag_amount notranslate">
          {{ amount | aztCurrency : currency }}
        </span>
        <span *ngIf="amountBeforeDiscount" class="price-tag_price-before-discount notranslate">
          &nbsp; {{ amountBeforeDiscount | aztCurrency : currency }} &nbsp;
        </span>
      </div>
      <app-loader *ngSwitchDefault view="flex" />
    </ng-container>
  </h2>
  <p class="price-tag_description">
    {{ 'offer.price-description' | translate }}
  </p>
  <button
    *ngIf="isAppAgentOrTravelAgency && !isBackoffice"
    (click)="showChangePremiumModal()"
    nxPlainButton
    type="button"
    class="price-tag_btn"
  >
    <nx-icon name="edit" class="nx-margin-right-2xs"></nx-icon>
    <span class="label"> {{ 'offer.change-premium' | translate }} </span>
  </button>
</section>
